<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <div
              class="d-flex"
              :class="$vuetify.breakpoint.smAndDown ? 'flex-column' : ''"
            >
              <div>
                <v-btn
                  small
                  class="white black--text d-print-none mr-4"
                  @click="$printReport()"
                >
                  <v-icon small left>mdi-printer</v-icon>
                  {{ $t("print") }}
                </v-btn>
              </div>
              <v-row
                no-gutters
                :class="$vuetify.breakpoint.smAndDown ? 'mt-2' : ''"
              >
                <CreatePromotion @promotionAdded="promotionAdded" />
                <!-- <v-btn
                  small
                  @click="createCasinoBonusDialog = true"
                  color="primary"
                  :disabled="true"
                >
                  <v-icon left>mdi-plus-box</v-icon>
                  {{ $t("freeRounds") }}
                </v-btn> -->
                <CreateCasinoBonus
                  v-if="false"
                  :dialog="createCasinoBonusDialog"
                  @closeDialog="createCasinoBonusDialog = false"
                />
              </v-row>
            </div>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3" sm="4">
              <div class="text-right align-end justify-end d-flex">
                <v-text-field
                  :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                  v-model="search"
                  style="max-width: 600px"
                  append-icon="mdi-magnify"
                  :label="$t('search')"
                  single-line
                  hide-details
                  dense
                  solo-inverted
                  clearable
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <div>
          <v-data-table
            :headers="headers"
            :items="data"
            :search="search"
            :items-per-page="10"
            class="elevation-1"
            :footer-props="{
              'items-per-page-text': this.$t('rowsPerPage'),
            }"
            :loading="loadingPromotions"
            :loading-text="$t('loadingPromotions')"
          >
            <template v-slot:item.id_promo="{ item }">
              <v-btn @click="$copy(item.id_promo)" x-small>
                {{ item.id_promo }}
              </v-btn>
            </template>
            <template v-slot:item.id_afiliado="{ item }">
              <v-btn
                v-if="item.id_afiliado != null"
                @click="$copy(item.id_afiliado)"
                x-small
              >
                {{ item.id_afiliado }}
              </v-btn>
              <div v-else class="text-center">
                ─
              </div>
            </template>
            <template v-slot:item.name_affiliate="{ item }">
              <div v-if="item.name_affiliate != null">
                {{ item.name_affiliate }}
              </div>
              <div v-else class="text-center">
                ─
              </div>
            </template>
            <template v-slot:item.date_inicial="{ item }">
              <span class="caption">{{ item.date_inicial }}</span>
            </template>
            <template v-slot:item.date_final="{ item }">
              <span class="caption">{{ item.date_final }}</span>
            </template>
            <!-- Não Exibe o "No data available" no data table -->
            <template slot="no-data">
              <div></div>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip :color="statusUI(item.status)" class="white--text" small>
                {{ statusValue(item.status) }}
              </v-chip>
            </template>

            <template v-slot:item.days_expiration="{ item }">
              <div class="d-flex">
                <span class="pr-2">
                  {{ item.days_expiration }}
                </span>
              </div>
            </template>

            <template v-slot:item.code_promo="{ item }">
              <template>
                <v-btn
                  v-if="item.type_promo != 'token'"
                  @click="$copy(item.code_promo)"
                  x-small
                >
                  {{ item.code_promo }}
                </v-btn>
                <div v-else class="text-center">
                  ─
                </div>
              </template>
            </template>

            <template v-slot:item.hide="{ item }">
              <span v-if="hasHideOption(item.type_promo)">
                {{ $t(item.hide == 0 ? "displayed" : "hidden") }}
              </span>
              <span v-else>
                ─
              </span>
            </template>

            <!-- ================== -->
            <!-- LISTAR ADESÕES HEADER -->
            <!-- ================== -->
            <template v-slot:header.list_adhesions="{ header }">
              <div class="d-flex align-center">
                <div>
                  <span>
                    {{ header.text }}
                  </span>
                </div>
                <div>
                  <th>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          class="d-print-none"
                        >
                          <v-icon small color="info">
                            mdi-information-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("adhesionTooltip") }}</span>
                    </v-tooltip>
                  </th>
                </div>
              </div>
            </template>
            <template v-slot:item.list_adhesions="{ item }">
              <DialogListAdhesions
                :id_promo="item.id_promo"
                :title="item.title"
                :bonus_total_resgatado="item.bonus_total_resgatado"
              />
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn-toggle>
                <ViewPromotion
                  :isReallyActive="status == '1' || status == '0'"
                  :affiliatePromotion="item.type_promo == 'afiliado'"
                  :affiliateName="item.name_affiliate"
                  :promotionId="item.id_promo"
                />
                <UpdatePromotion
                  :promotion="{ ...item, isReallyActive: status == '1' }"
                  @refreshPromotions="listPromotions"
                />
                <ConfirmPromotionDelete
                  :promotion="{ ...item, isReallyActive: status == '1' }"
                  @refreshPromotions="listPromotions"
                />
                <AddPromotionUser
                  v-if="item.type_promo !== 'token'"
                  :promotion="{ ...item, isReallyActive: status == '1' }"
                />
                <ExportPromotionTokens
                  v-else
                  :promotion="{ ...item, isReallyActive: status == '1' }"
                />
              </v-btn-toggle>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";
import CreatePromotion from "./createPromotion.vue";
import DialogListAdhesions from "./dialogListAdhesions.vue";
import CreateCasinoBonus from "./createCasinoBonus";
import ConfirmPromotionDelete from "./ConfirmPromotionDelete";
import UpdatePromotion from "./UpdatePromotion";
import ViewPromotion from "./ViewPromotion";
import AddPromotionUser from "./AddPromotionUser";
import ExportPromotionTokens from "./exportPromotionTokens";

export default {
  name: "views-backoffice-administrator-bonus-listBonusOnline",
  components: {
    HeaderPrint,
    CreatePromotion,
    DialogListAdhesions,
    CreateCasinoBonus,
    ConfirmPromotionDelete,
    UpdatePromotion,
    ViewPromotion,
    AddPromotionUser,
    ExportPromotionTokens,
  },
  data: () => ({
    search: "",
    data: [],
    days: "",
    createCasinoBonusDialog: false,
    loadingPromotions: false,
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t("idPromotion"),
          value: "id_promo",
          align: "center",
        },
        {
          text: this.$t("dateStart"),
          value: "date_inicial",
          align: "center",
        },
        {
          text: this.$t("dateFinal"),
          value: "date_final",
          align: "center",
        },
        {
          text: this.$t("idAffiliate"),
          value: "id_afiliado",
          align: "center",
        },
        {
          text: this.$t("affiliate"),
          value: "name_affiliate",
          align: "center",
        },
        {
          text: this.$t("status"),
          value: "status",
          align: "center",
        },
        // {
        //   text: this.$t('daysToExpireTableHeader'),
        //   value: "days_expiration",
        // },
        {
          text: this.$t("type"),
          value: "typeUI",
          align: "center",
        },
        {
          text: this.$t("promotionCodeTableHeader"),
          value: "code_promo",
          align: "center",
        },
        {
          text: this.$t("adhesions"),
          value: "list_adhesions",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("visibility"),
          value: "hide",
          align: "center",
        },
        {
          text: this.$t("actions"),
          value: "actions",
          align: "center",
          sortable: false,
        },
      ];
    },
    // Status for Dialog Create Promotion
    dialog() {
      return this.$store.state.showDialog;
    },
    // Status Dialog Inactive Promotion
    refreshPromotions() {
      return this.$store.state.refreshPromotions;
    },
    url() {
      return this.$store.state.url;
    },
    status() {
      return this.$store.state.filters.selectStatus.status;
    },
    // saveFilters() {
    //   return this.$store.state.filters.save;
    // },
  },
  beforeCreate() {
    this.$store.commit("setSelectStatus", 1);
  },
  created() {
    // Push necessário caso o usuário use F5 quando a dialog listAdhesions estiver aberta
    this.$router.push({ name: "ListPromotionOnline" }).catch(() => {});
  },
  mounted() {
    this.listPromotions();
  },
  watch: {
    status() {
      this.listPromotions();
    },
    // saveFilters(val) {
    //   !!val && this.listPromotions();
    // },
  },
  methods: {
    reset() {
      this.data = [];
    },
    listPromotions() {
      this.data = [];
      const body = {
        status: this.status,
      };
      this.loadingPromotions = true;
      this.$request
        .post("/administrator/promotions/listPromotions", body)
        .then((response) => {
          if (!response.dados) return;
          this.data = response.dados;
          this.data.forEach((item) => {
            if (item.hide) {
              item.hide = this.hasHideOption(item.type_promo)
                ? Number(item.hide)
                : -1;
            }
            item.date_inicial = new Date(
              item.date_inicial.replace(" ", "T")
            ).toLocaleString();
            item.date_final = new Date(
              item.date_final.replace(" ", "T")
            ).toLocaleString();
            item.percentage =
              item.percentage == 1 ? this.$t("yes") : this.$t("no");
            if (item.nome == null) {
              item.nome = "";
            }
            item.typeUI = this.typeUI(item.type_promo);
          });
          this.$store.commit("setRefreshPromotions", false);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingPromotions = false;
        });
    },
    statusUI(value) {
      if (value == 0) return "warning"; // Em Análise
      if (value == 1) return "green"; // Ativa
      if (value == 2) return "grey darken-4"; // Suspensa
      if (value == 3) return "purple darken-2"; // Encerrada
    },
    typeUI(value) {
      const obj = {
        // campanha: this.$t("campaing"),
        cadastro: this.$t("register"),
        afiliado: this.$t("affiliate"),
        "1ºdeposito": this.$t("firstDeposit"),
        deposito: this.$t("deposit"),
        token: this.$t("token"),
      };
      return obj[value];
    },
    statusValue(value) {
      const obj = {
        0: this.$t("documentInAnalysis"),
        1: this.$t("activePromo"),
        2: this.$t("suspensa"),
        3: this.$t("encerrada"),
      };
      return obj[value];
    },
    // onPromotionDelete() {
    //   this.getPromotions();
    // },
    promotionAdded() {
      this.$store.commit("setSelectStatus", 1);
      this.listPromotions();
    },
    hasHideOption(promotionType) {
      const hasHideOption = ["deposito", "1ºdeposito", "cadastro"];

      return hasHideOption.includes(promotionType);
    },
  },
};
</script>
